export const MEMBERSHIP_STORE_CHANGED = 'MEMBERSHIP_STORE_CHANGED' as const;
export const MEMBERSHIP_STORE_CHANGED_ACTION_TYPE = {
  OWNER_MOVE: 'MOVE',
  OWNER_CONNECT: 'CONNECT',
  OWNER_DISCONNECT: 'DISCONNECT',
} as const;
